// import Constants from './constants/Addison';
import DeviceInfo from './tools/DeviceInfo';
import Footer from './includes/Footer';
import Index from './pages/Index';
import Packages from './pages/Packages';
import Faq from './pages/Faq';
import Reservation from './pages/Reservation';
import Contact from './pages/Contact';
import Franchise from './pages/Franchise';
import Default from './pages/Default';
import Vip from './pages/Vip';


/**
 * Main entry point of the website.
 *
 * @copyright Swoo Inc
 * @website http://swoo.ca
 * @author Jonathan Simard <jonathan@swoo.ca>
 */
class Main{

    /**
     * Constructor of the class.
     *
     * @return void
     */
    constructor(){

    	document.addEventListener('DOMContentLoaded', this.init.bind(this));

    }

    /**
     * Initialize the class when the DOM is ready.
     *
     * @return void
     */
    init(){

        console.log('Main :: init');

        //Polyfill nodelist ie
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }

        DeviceInfo.check();
        this.initialize();
    }

    /**
     * Initialize the page.
     *
     * @return void
     */
    initialize(){

       	const section = document.querySelector('section.main');

        this.page = null;

        switch( true ) {

            case section.classList.contains('index'):
                this.page = new Index('index', section);
                break;

            case section.classList.contains('packages'):
                this.page = new Packages('packages', section);
                break;

            case section.classList.contains('faq'):
                this.page = new Faq('faq', section);
                break;

            case section.classList.contains('reservation'):
                this.page = new Reservation('reservation', section);
                break;

            case section.classList.contains('contact'):
                this.page = new Contact('contact', section);
                break;

            case section.classList.contains('franchise'):
                this.page = new Franchise('franchise', section);
                break;

            case section.classList.contains('vip'):
                this.page = new Vip('vip', section);
                break;

            default:
                this.page = new Default('default', section);

        }

    }
}
new Main();
